var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "default-warehouse",
                        label: "Default Warehouse",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "defaultWarehouse",
                          options: _vm.optionsWarehouseDLL,
                        },
                        model: {
                          value: _vm.defaultWarehouse,
                          callback: function ($$v) {
                            _vm.defaultWarehouse = $$v
                          },
                          expression: "defaultWarehouse",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { "label-for": "vat-number", label: "VAT Number" },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "vatNumber",
                          placeholder: "Enter VAT Number",
                        },
                        model: {
                          value: _vm.vatNumber,
                          callback: function ($$v) {
                            _vm.vatNumber = $$v
                          },
                          expression: "vatNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { "label-for": "brn", label: "BRN" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "brn", placeholder: "Enter BRN" },
                        model: {
                          value: _vm.brn,
                          callback: function ($$v) {
                            _vm.brn = $$v
                          },
                          expression: "brn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mt-1 mr-1",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCompanySettings()
                        },
                      },
                    },
                    [
                      _vm.showSpinner
                        ? _c("b-spinner", { attrs: { label: "Spinning" } })
                        : _vm._e(),
                      _vm._v(" Save "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }